import React, { useEffect, useState } from 'react';

interface PWASplashScreenProps {
  onLoadComplete?: () => void;
}

export const PWASplashScreen: React.FC<PWASplashScreenProps> = ({ 
  onLoadComplete 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Mostrar splash screen por al menos 1.5 segundos para mejor UX
    const timer = setTimeout(() => {
      setIsLoading(false);
      setIsVisible(false);
      
      // Llamar al callback cuando se complete
      if (onLoadComplete) {
        setTimeout(onLoadComplete, 300); // Esperar a que termine la transición
      }
    }, 1500);

    return () => {
      clearTimeout(timer);
    };
  }, [onLoadComplete]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${!isLoading ? 'hidden' : ''}`}>
      <img 
        src="/assets/ots/ots_generic.png" 
        alt="Servicio a Tiempo" 
        className="splash-logo"
      />
    </div>
  );
};

// Hook para detectar si la app está en modo PWA
export const usePWAMode = () => {
  const [isPWAMode, setIsPWAMode] = useState(false);

  useEffect(() => {
    const checkPWAMode = () => {
      // Verificar si la app está en modo standalone (PWA)
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      // Verificar si está en modo fullscreen (PWA en iOS)
      const isFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
      // Verificar si está en modo minimal-ui (PWA en algunos navegadores)
      const isMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
      
      setIsPWAMode(isStandalone || isFullscreen || isMinimalUI);
    };

    checkPWAMode();
    
    // Escuchar cambios en el modo de visualización
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    mediaQuery.addEventListener('change', checkPWAMode);
    
    return () => {
      mediaQuery.removeEventListener('change', checkPWAMode);
    };
  }, []);

  return isPWAMode;
};

// Componente que solo se muestra en modo PWA
export const PWASplashScreenOnly: React.FC<{ onLoadComplete?: () => void }> = ({ 
  onLoadComplete 
}) => {
  usePWAMode();
  
  // Temporalmente mostrar siempre para debugging
  const shouldShow = true; // isPWA;

  if (!shouldShow) return null;

  return <PWASplashScreen onLoadComplete={onLoadComplete} />;
};
